import API from "../../api";
import { API_SEARCH_LOG_USER } from "../../constants/api";

const searchLogs = async (data) => {
  try {
    const response = await API.get(API_SEARCH_LOG_USER, {
      params: data,
    });
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const UserUpdateHistorySearch = {
  searchLogs,
};

export {
  UserUpdateHistorySearch as default,
  searchLogs,
}
